<template>
    <div style="margin: 10px 40px 0px">
      <el-form style="margin-right: 25px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addEditForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="jobnum">
          <el-input v-model="addEditForm.jobnum" placeholder="请输入工号"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input type="number" v-model="addEditForm.phone" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="所属服务商" prop="soid">
          <el-select v-fixZoom filterable v-model="addEditForm.soid" placeholder="请选择服务商" style="width: 100%">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小程序账号" prop="">
          <el-radio-group v-model="addEditForm.is_open_applet">
            <el-radio :label="0">不开通</el-radio>
            <el-radio :label="1">开通</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="小程序密码" prop="" v-if="addEditForm.is_open_applet === 1">
          <el-input type="password" v-model="addEditForm.mini_pwd" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAdd()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEdit('addEditForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 30px"></div>
    </div>
</template>

<script>
import {addsupplierorgperson, updatesupplierorgperson} from '../../../api/serviceMark'
export default {
  name: 'addEditSperson',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEdit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isAdd: true,
      options: [],
      addEditForm: {
        id: '',
        name: '',
        jobnum: '',
        phone: '',
        soid: '',
        is_open_applet: 0,
        mini_pwd: ''
      },
      addEditRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        jobnum: [
          { required: true, message: '请输入工号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        soid: [
          { required: true, message: '请选择所属服务商', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.isAdd = this.addEdit.isAdd
      this.options = this.addEdit.supplierorg
      if (this.isAdd) {
        this.addEditForm.id = 0
      } else {
        this.addEditForm.id = this.addEdit.row.id
        this.addEditForm.name = this.addEdit.row.name
        this.addEditForm.jobnum = this.addEdit.row.jobnum
        this.addEditForm.phone = this.addEdit.row.phone
        this.addEditForm.soid = this.addEdit.row.soid
        this.addEditForm.is_open_applet = this.addEdit.row.is_open_applet
      }
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            addsupplierorgperson(this.addEditForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加服务商人员',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTableSuser()
              this.$emit('change', false)
            }).catch(() => {})
          } else {
            updatesupplierorgperson(this.addEditForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改服务商人员',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTableSuser()
              this.$emit('change', false)
            }).catch(() => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/addEditSperson.vue